import type { ExtractPropTypes, ExtractPublicPropTypes, PropType } from 'vue';
import type Checkbox from './checkbox.vue';

export const CheckboxProps = {
  modelValue: Object,
  disabled: Boolean,
  fill: String,
  textColor: String,
  size: {
    type: String as PropType<'large' | 'default' | 'small' | ''>,
    default: '',
  },
  min: Number,
  max: Number,
  type: {
    type: String as PropType<'button' | ''>,
    default: '',
  },
  border: Boolean,
  data: {
    type: [String, Array],
    default: () => [],
  },
  dataCallback: {
    type: Function,
  },
  optLabel: {
    type: String,
    default: 'label',
  },
  optValue: {
    type: String,
    default: 'value',
  },
};

export const CheckboxEmits = {
  'update:modelValue': (value: any) => value,
  change: (value: any) => value,
};

export const excludeCheckboxKeys = ['type', 'data', 'border', 'dataCallback', 'optLabel', 'optValue', 'modelValue'];

export type CheckboxPropsType = ExtractPropTypes<typeof CheckboxProps>;
export type CheckboxPublicPropsType = ExtractPublicPropTypes<typeof CheckboxProps>;
export type CheckboxInstance = InstanceType<typeof Checkbox>;
